import React from 'react'
import { AppSelectionBar, AppSelectionBarButton } from "@components"
import useMultipleActions from 'Pages/Admin/AdminMapping/Table/@hooks/useMultiple'


export default function AdminMappingToolbarSelect({ selectedData, setSelectedRows, path }) {
	const { handleRemoveMultipleMappings, isLoadingDelete } = useMultipleActions(selectedData, setSelectedRows, path)

	return <AppSelectionBar count={selectedData?.length || 0} onClear={() => setSelectedRows([])}>
		<AppSelectionBarButton
			icon="trash"
			label={isLoadingDelete ? 'Deleting…' : 'Delete'}
			title="Delete multiple mappings"
			danger
			disabled={!!isLoadingDelete}
			onClick={handleRemoveMultipleMappings}
		/>
	</AppSelectionBar>
}